export const TYPES = {
  SELECT_ALL_DISCOUNT_SUCCESS: "refund/SELECT_ALL_DISCOUNT_SUCCESS",
};
